module.exports = __webpack_public_path__ + "img/double-play-icon.75b2774e.svg";